module.exports = __webpack_public_path__ + "static/img/3-3.dbdf49a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-3.jpg
// module id = ZdjX
// module chunks = 1